import { Button, Box, Typography, CircularProgress } from "@mui/material";
import { useState } from "react";
import SnackbarAlert from "./SnackbarAlert";
const CSVUpload = ({
  handleFileUpload,
  errorMessage,
  csvUploadEnabled,
  fileNumber,
  fileInputRef,
  multipleCsvUplaodEnabled,
  userSelection,
  csvFileNameStartLatters,
  csvFileNameEndWith
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFileValidation = (e) => {
    const file = e.target.files[0];
    if (multipleCsvUplaodEnabled) {

      if (fileNumber === 1) {
        const isValidStart = csvFileNameStartLatters.some((startLetter) =>
          file.name.startsWith(`${startLetter}`)
        );
        if (!isValidStart) {
          e.target.value = null;
          setSnackbarMessage(
            `File name must start with one of the following: ${csvFileNameStartLatters.join(", ")} for the file.`
          );
          setOpenSnackbar(true);
          return;
        }
      }
      if (fileNumber === 2) {
          const isValidStart = csvFileNameEndWith.some((endLatter) =>
          file.name.endsWith(`${endLatter}`)
        );
        if (!isValidStart) {
          e.target.value = null;
          setSnackbarMessage(
            `File name must end with one of the following:  ${csvFileNameEndWith.join(", ")} for the second file.`
          );
          setOpenSnackbar(true);
          return;
          
        }
      }
    }
    else{
        if (fileNumber === 1 && csvFileNameStartLatters) {
        const isValidStart = csvFileNameStartLatters?.some((startLetter) =>
          file.name.startsWith(`${startLetter}`)
        );
        if (!isValidStart) {
          e.target.value = null;
          setSnackbarMessage(
            `File name must start with one of the following: ${csvFileNameStartLatters.join(", ")} for the file.`
          );
          setOpenSnackbar(true);
          return;
        }
      }
    }
    handleFileUpload(e, fileNumber);
  };
  return (
    csvUploadEnabled && (
      <>
        {multipleCsvUplaodEnabled && userSelection && (
          <Typography variant="body2" color="textSecondary" fontWeight="bold">
            {fileNumber === 1 ? "Main File" : "Second File"}
          </Typography>
        )}

        <div style={{ width: "100%", margin: "0 20px" }}>
          <input
            ref={fileInputRef}
            id={`csvFile-${fileNumber}`}
            type="file"
            accept=".csv"
            onChange={handleFileValidation}
          />
          {errorMessage && <div>{errorMessage}</div>}
        </div>
        {/* Snackbar for alerts */}
        <SnackbarAlert
          open={openSnackbar}
          message={snackbarMessage}
          severity="error"
          onClose={handleCloseSnackbar}
        />
      </>
    )
  );
};
export default CSVUpload;
